define('NVT.anuualupdateform.anuualupdateformAuthRepresantative.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_auth_represantative.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_myorganisation_auth_represantative_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_myorganisation_auth_represantative_tpl

        ,   title: Utils.translate('Authorised Representative’s Details')

        ,   initialize: function(options)
            {
                this.options = options;
                this.getjsonrequest = options.getjsonrequest;
                this.application = options.application;
                this.page_header =  Utils.translate('Authorised Representative’s Details');
                this.modalClass ='modal-lg';  
                var self = this;
                BackboneFormView.add(this);
            }

        ,    events: 
            {
              'submit form': 'saveTheForm'
            }   
           
        ,   validateEmail : function (email) {
                var self = this;
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }


        ,   saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	getfielddata = $target.serializeObject();
                    getfielddata.folderlocfile = SC.CONFIGURATION.MyOrganisation.BizFileAttachmentId;

                    if(!getfielddata.nus_org_name.trim())
                    {
                        self.showMessage('Full Name is required', 'error','nus_org_name');  
                    }
                    else if(!getfielddata.nus_org_job_title.trim())
                    {
                        self.showMessage('Job title is required', 'error','nus_org_job_title');  
                    }
                    else if(!getfielddata.signature.trim())
                    {
                        self.showMessage('Signature is required', 'error','signature');
                    }
                    else if(!getfielddata.signature.trim())
                    {
                        self.showMessage('Signature is required', 'error','signature');
                    }
                    else if(!getfielddata.nus_ems_name.trim())
                    {
                        self.showMessage('Full name is required', 'error','nus_ems_name');  
                    }
                    else if(!self.validateEmail(getfielddata.nus_email_address))
                    {
                        self.showMessage('Business email address id required', 'error','nus_email_address');  
                    }
                    else if(!getfielddata.nus_job_title.trim())
                    {
                        self.showMessage('Job title is required', 'error','nus_job_title');
                    }
                    // else if(!getfielddata.nus_phone_no || getfielddata.nus_phone_no.length < 8)
                    // {
                    //     self.showMessage('Phone number is required, minimum 8 digit.', 'error','nus_phone_no');
                    // }
                    else if(getfielddata.formtypes != 'authrepresentative')
                    {
                        self.showMessage('Invalid form requested', 'error');  
                    }
                    else{

                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                        return promise && promise.then
                        (
                            function(responce)
                            {
                                if (responce.successMessage)
                                {
                                    self.showMessage(responce.successMessage, 'success');
                                }
                                else {
                                    self.showMessage(responce.errorMessage, 'error')
                                }
                                return false;   
                            }
                        );
                    }               
               
            }

        ,   showMessage: function(message, type, field)
            {
                jQuery('.global-views-message-error').remove(); 
                jQuery('.global-views-message-success').remove(); 

                var messageView = new MessageView
                ({
                        message: message
                    ,   type: type
                    ,   closable: type =='error' ? true : false
                });
                if (typeof field !== 'undefined')
                {
                    this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else if (type =='error'){
                    this.application.getLayout().$('form').append(messageView.render().$el);
                }
                else
                {
                    this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                    setTimeout(function() {
                        jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                    }, 1000);
                }
            }    

            
        ,   getContext: function() {
            
            var self = this;

                    return {
                
                    title : this.title,

                    addcompname : '', //this.options.compname || '',

                    addjobtitle : '', // this.options.jobtitle || '',

                    internalid : this.options.internalid || '',

                    requestbyemail : self.options.cutomuparamsemail,

                    folderlocfile : SC.CONFIGURATION.MyOrganisation.BizFileAttachmentId

                }
            }        

    });
});
